// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalGraph_root__3J8Jv","empty":"ModalGraph_empty__39yr9"};